import { Checkout } from "./Checkout";
import { WindowElement } from "./WindowElement";

const create: typeof Checkout.create = Checkout.create;
const submit: typeof Checkout.submit = Checkout.submit;
const update: typeof Checkout.update = Checkout.update;
const submitBySplitId: typeof Checkout.submitBySplitId = Checkout.submitBySplitId;
const updateBySplitId: typeof Checkout.updateBySplitId = Checkout.updateBySplitId;
const validate: typeof Checkout.validate = Checkout.validate;

const storeInWindow = () => {
    const checkoutPublicParams = { create, submit, update, submitBySplitId, updateBySplitId, validate, loaded: true };
    window.UnivapayCheckout = checkoutPublicParams;
    window.GopayCheckout = checkoutPublicParams;
};

if (!window.UnivapayCheckout?.loaded) {
    storeInWindow();
    WindowElement.createWindowElements(true);
}
